import React from 'react';
import { AiOutlineEdit } from 'react-icons/ai';
import { MdOutlineAutoDelete } from 'react-icons/md';

interface Data {
  [key: string]: any;
}

interface Column {
  Header: string;
  accessor?: string;
  Cell?: (value: any) => React.ReactNode;
}

interface TableProps {
  columns: Column[];
  data: Data[] | undefined;
  onEdit?: (rowData: Data) => void;
  onDelete?: (rowData: Data) => void;
  itemsPerPage?: number;
}

const Table: React.FC<TableProps> = ({ columns, data, onEdit, onDelete }) => {
  return (
    <div className="divTable w-[100%] rounded-2xl overflow-x-scroll overflow-y-hidden border border-gray-300 my-4 shadow-md">
      <table className="w-full border-collapse text-center">
        <thead className="bg-[#00AEEF] text-white font-bold">
          <tr>
            {columns.map((column) => (
              <th
                key={column.Header}
                className="p-[.8rem] min-w-[150px] whitespace-nowrap text-center"
              >
                {column.Header}
              </th>
            ))}
            {onEdit && (
              <th className="p-[.8rem] min-w-[100px] whitespace-nowrap text-center">
                Ações
              </th>
            )}
          </tr>
        </thead>
        <tbody>
          {data &&
            data.map((row, rowIndex) => (
              <tr
                key={rowIndex}
                className="border-b border-gray-300 hover:bg-gray-100"
              >
                {columns.map((column) => (
                  <td
                    key={column.Header}
                    className="p-[.8rem] min-w-[150px] text-center"
                  >
                    {column.Cell
                      ? column.Cell({ value: row[column.accessor || ''], row })
                      : row[column.accessor || '']
                    }
                  </td>
                ))}
                {onEdit && (
                  <td className="px-2 py-2 text-sm font-medium text-gray-900 text-center">
                    <div className="flex justify-center gap-2">
                      <button onClick={() => onEdit(row)}>
                        <AiOutlineEdit className="text-2xl text-green-600" />
                      </button>
                      {onDelete && (
                        <button onClick={() => onDelete(row)}>
                          <MdOutlineAutoDelete className="text-2xl text-red-600" />
                        </button>
                      )}
                    </div>
                  </td>
                )}
              </tr>
            ))}
        </tbody>
      </table>
    </div>
  );
};

export default Table;
